import { useState, useEffect } from 'react';
import { ReactTyped } from 'react-typed';


export default function Ladataan(props) {

  const [waiting, setWaiting] = useState(true);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setWaiting(false);
    }, 2000)
    return () => clearTimeout(timerId);
  }, [setWaiting])

  if (waiting) return null;
  return (
    <div className="App">
      <div style={{ zIndex: 1, position: "relative" }}>
        <ReactTyped className="typed"
          strings={["Ladataan..."]}
          typeSpeed={50}
          backSpeed={50}
          loop={true}
        />
      </div>
    </div>
  );

}
